"use client";
import {
  _highlight,
  _renderHighlight,
  highlight
} from "../chunk-VD7J34CI.js";
import "../chunk-MLKGABMK.js";

// src/utils/use-shiki.tsx
import {
  use,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { jsx } from "react/jsx-runtime";
var jsEngine;
function getHighlightOptions(from) {
  if (from.engine) return from;
  if (!jsEngine) {
    jsEngine = import("shiki/engine/javascript").then(
      (res) => res.createJavaScriptRegexEngine()
    );
  }
  return {
    ...from,
    engine: jsEngine
  };
}
var cache = /* @__PURE__ */ new Map();
function useShiki(code, {
  defaultValue,
  scriptKey,
  ...options
}, deps) {
  const key = useMemo(
    () => deps ? JSON.stringify(deps) : `${options.lang}:${code}`,
    [code, deps, options.lang]
  );
  const shikiOptions = getHighlightOptions(options);
  const currentTask = useRef({
    key,
    aborted: false
  });
  const [rendered, setRendered] = useState(() => {
    if (defaultValue) return defaultValue;
    const cached = cache.get(key);
    if (cached) return cached;
    const hast = globalThis._use_shiki?.get(scriptKey);
    if (hast) {
      const node = _renderHighlight(hast, shikiOptions);
      cache.set(key, node);
      return node;
    }
    currentTask.current = void 0;
    const Pre = options.components?.pre ?? "pre";
    const Code = options.components?.code ?? "code";
    return /* @__PURE__ */ jsx(Pre, { children: /* @__PURE__ */ jsx(Code, { children: code }) });
  });
  if (typeof window === "undefined") {
    return use(highlight(code, shikiOptions));
  }
  if (!currentTask.current || currentTask.current.key !== key) {
    if (currentTask.current) {
      currentTask.current.aborted = true;
    }
    const task = {
      key,
      aborted: false
    };
    currentTask.current = task;
    highlight(code, shikiOptions).then((result) => {
      cache.set(key, result);
      if (!task.aborted) setRendered(result);
    });
  }
  return rendered;
}
function PrerenderScript({
  scriptKey,
  code,
  options
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const tree = typeof window === "undefined" ? use(_highlight(code, getHighlightOptions(options))) : (
    // @ts-expect-error -- typed
    globalThis._use_shiki?.get(scriptKey)
  );
  if (mounted || !tree) return null;
  return /* @__PURE__ */ jsx("script", { children: `if (typeof globalThis._use_shiki === "undefined") globalThis._use_shiki = new Map()
globalThis._use_shiki.set(${JSON.stringify(scriptKey)}, ${JSON.stringify(tree)})` });
}
export {
  PrerenderScript,
  useShiki
};
